import React, { useRef, useEffect, useState } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { message, Checkbox, Table } from "antd";
import { FormItemTypeEnum, IYhForm, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { useMaintenanceModel } from "../maintenanceModel"
import { YhForm } from "@/components/YhFormBox";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { formatNum } from "@/utils/utils";
import { PlusOutlined, DeleteOutlined, CodeSandboxCircleFilled } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import useGlobalModel from "@/model/globalModel";
import { itemService } from "@/views/base/item/itemService";
//结算
export interface ISalePayMethod {
    branch?: string, //"vrm-nga",
    tradeCode?: string, //"NGAWXD202104190005",
    payMethodCode?: string, //"pay-method.cash.wechat",
    payMethodName?: string, //"微信",
    payAmount?: number, //"100",
    payee?: string, //""
    key?: string,
    id?: string,
}
export enum IVRMSettleTypeEnum {
    SETTLE_CREDIT = "settle-type.credit", //挂账
    SETTLE_CASH = "settle-type.cash"  //现金
}
export const SettleDrawer = () => {
    const { user } = useGlobalModel()

    const { settleVisible: visible, setSettleVisible, loadData, selectedRow, Settle, setSelectedRow } = useMaintenanceModel()
    const formRef = useRef<IYhFormRef>();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const initDataSource: ISalePayMethod = {
        key: new Date().getTime().toString(),
        payMethodCode: "",
        payMethodName: "",
        payAmount: 0,
        payee: "",
    };
    const [settleType, setSettleType] = useState<string>(IVRMSettleTypeEnum.SETTLE_CASH);   //结算类型，  默认现金结账
    const [payDataSource, setPayDataSource] = useState<ISalePayMethod[]>([]);  //表格默认值
    const [accountTypeDs, setAccountTypeDs] = useState<ISelectOption[]>([]) //实时存取收款账户类型值
    const [payMethodList, setPayMethodList] = useState<ISelectOption[]>([])//根据结算类型筛选出对应结算方式
    useEffect(() => {
        if (visible) {
            let { payDetails, itemDetails, materialDetails, ...params } = selectedRow
            formRef.current?.setFieldsValue({ ...selectedRow, note: "" });
            payDetails?.length ? setPayDataSource(payDetails as ISalePayMethod[]) : setPayDataSource([{...initDataSource,payAmount:params.receivableTotalAmount}]);
            setSettleType(selectedRow.payType as IVRMSettleTypeEnum);
            filterPayMethodList(selectedRow.payType as IVRMSettleTypeEnum)
        }
    }, [visible])
    const onSubmit = () => {
        let filterPayData = payDataSource.filter(item => (item.payMethodCode));
        if (settleType == IVRMSettleTypeEnum.SETTLE_CASH && filterPayData.length !== payDataSource.length) {
            message.warning("请完善收款信息");
            return;
        }
        let totalAmount: number = filterPayData.reduce((con, next) => { con += +(next.payAmount ?? 0); return con }, 0);
        if (settleType == IVRMSettleTypeEnum.SETTLE_CASH && totalAmount !== +(selectedRow.receivableTotalAmount as number)) {
            message.warning("您结算的金额与应收金额有差异");
            return;
        }
        formRef.current?.validateFields().then(async res => {
            let newDetails = payDataSource.map((item, index) => {
                let { key, ...params } = item
                return {
                    ...params,
                    branch: "vrm-nga-yh",
                    tradeCode: res.maintenanceCode,
                }
            }
            )
            let data = {
                id: selectedRow.id,
                maintenanceCode: res.maintenanceCode,
                reckoner: user.username,
                payType: res.payType,
                note: res.note,
                details: settleType == IVRMSettleTypeEnum.SETTLE_CASH ? newDetails : []
            }
            try {
                let retData = await Settle(data)
                message.success("结算成功");
                onCancel()
                loadData()
                // loadData().then(res => setSelectedRow(origin => res.find(item => origin[0].id === item.id) ?? []))
            } catch (error) {
                onCancel()
            }
        })
    }
    const onCancel = () => {
        setSettleVisible(false)
    }
    const onFinish = () => {
    }
    const onChange = () => {

    }
    const settleTypeChange = (value: string, option: ISelectOption) => {
        setSettleType(option.value)
        // filterSelectDictOne()
        // let newPayMethodList = getSelectedDictOne(DictCodeEnmu.PAY_METHOD).filter(item => item.sign === option.value)
        // setPayMethodList(newPayMethodList)
        filterPayMethodList(option.value)
    }
    const filterPayMethodList = (sign: string) => {
        let newPayMethodList = getSelectedDictOne(DictCodeEnmu.PAY_METHOD).filter(item => item.sign === sign)
        setPayMethodList(newPayMethodList)
    }
    const formConfig: IYhForm<any> = {
        formRef,
        onFinish,
        labelCol: { span: 6 },
        disabled: selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io",
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单单号",
                fieldName: "maintenanceCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单日期",
                fieldName: "createTime",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户编码",
                fieldName: "customerCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算日期",
                fieldName: "settleTime",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠金额",
                fieldName: "discountTotalAmount",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "应付金额",
                fieldName: "receivableTotalAmount",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                onSelectChange: settleTypeChange,
                span: 12,
                // disable: true
                // }, {
                //     type: FormItemTypeEnum.Select,
                //     fieldLabel: "结算方式",
                //     fieldName: "payMethodCode",
                //     // options: getSelectedDictOne(DictCodeEnmu.PAY_METHOD),
                //     span: 12,
                // disable: true                
            }, 
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "备注",
            //     fieldName: "note",
            //     // span: 12,
            //     span: 24,
            //     labelCol: { span: 3 },
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务备注",
                fieldName: "fmsNote",
                // span: 12,
                span: 24,
                labelCol: { span: 3 },
            },


        ]
    };

    const columns = [
        {
            title: '结算方式',
            dataIndex: 'payMethodCode',
            editType: "select",
            // options: getSelectedDictOne(DictCodeEnmu.PAY_METHOD),
            options: payMethodList,
            width: 150,
            editable: !!!(selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io"),
            render: (text: string) => getTreeNodeName(text)

        }, {
            title: '结算金额',
            width: 120,
            dataIndex: 'payAmount',
            editable: !!!(selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io"),
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '收款人',
            editable: !!!(selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io"),//true,
            dataIndex: 'payee',
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.PAYEE),
            width: 150,
            render: (text: string) => getTreeNodeName(text)
        }, {
            align: "center",
            title: '操作',
            width: 100,
            render: (text: any, record: any) =>
                !!!(selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io") && <div className="flex justify-around">
                    <PlusOutlined
                        style={{ fontSize: '18px', cursor: 'pointer' }}
                        onClick={() => setPayDataSource(() => [...payDataSource, initDataSource])}
                    />
                    <DeleteOutlined
                        style={{ fontSize: '18px', cursor: 'pointer' }}
                        onClick={() => setPayDataSource(() => payDataSource.filter(item => item.key !== record.key))}
                    />
                </div>,
        }
    ]
    const newPayColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISalePayMethod, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })
    //内联编辑
    const handleSave = (row: ISalePayMethod) => {
        row.payAmount = +formatNum(row.payAmount);

        // //结算类型为挂账时， 判断支付方式有值时候 去对应的可用额度
        // if (settleType === IVRMSettleTypeEnum.SETTLE_CREDIT) {
        //     // if (row.payMethodCode) {
        //     //     // debugger;
        //     //     let find = accountTypeDs.find(item => item.value === row.payMethodCode);
        //     //     row.payMethodName = find?.label ?? "";
        //     //     row.available = +(find?.available ?? 0);
        //     // }
        //     // if (+row.amount > +(row.available ?? 0)) {
        //     //     row.amount = "0";
        //     //     message.warning("结算金额≤可用额度");
        //     // }
        //     // row.amount = formatInt(row.amount, +(row.available ?? 0), "结算金额≤可用额度");
        // } else if (settleType === IVRMSettleTypeEnum.SETTLE_CASH) {
        //     if (row.payMethodCode) {
        //         // row.payMethodName = getTreeNodeName(row.payMethodCode) ?? "";;
        //     }
        // }
        row.payMethodName = getTreeNodeName(row.payMethodCode as string) ?? "";;

        let dataSource: ISalePayMethod[] = [...payDataSource];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setPayDataSource(dataSource);
    }
    return (
        <YHDrawer
            {...{
                title: '维修开单结算',
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                width: 700,
                showFooter: !!!(selectedRow?.status == "maintenance.settle" || selectedRow?.status == "maintenance.stock-io"),
            }}
        >
            <YhForm {...formConfig} />
            <Table
                // size="small"
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newPayColumns as ColumnsType<ISalePayMethod>}
                dataSource={payDataSource}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
            {/* <div className="table-bottom-total" onClick={() => { }}>合计:<span className="ml-15 statu-red">{`￥${formatNum(payDataSource.reduce((con, next) => { con += +(next.amount ?? 0); return con }, 0))}`}</span></div> */}
        </YHDrawer>
    )

}